import React, { Component } from 'react';
import {
  withStyles, Tab, Tabs, Divider,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { ListItem } from '@trdk/style/List';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import EditButton from '@material-ui/icons/Edit';
import Hidden from '@material-ui/core/Hidden';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItemSecondaryActions from '@material-ui/core/ListItemSecondaryAction';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import NotificationBar from '@trdk/style/NotificationBar';
import { fetchClear } from '../../../services/fetch/fetch.actions';
import { updateSelectedTable, updateSelectedPage, doFetch as doFetchUser } from './users.actions';
import { fetchUsers } from '../../../services/admin/user-service';
import * as userConstants from './functions/constants';

const rolesDisplay = {
  politician: 'Politiker',
  admin: 'Administrator',
  superadmin: 'Superadministrator',
  secretary: 'Sekretær',
  observer: 'Observatør',
  other: 'Andre',
};

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      currentRowPerPage: 10,
    };
  }

  componentDidMount() {
    const {
      users: {
        fetched,
        fetching,
        error,
      },
      dispatch,
    } = this.props;

    if (!fetched && !fetching) {
      dispatch(this.loadUsers());
    }
    dispatch(fetchClear('ADD_USER'));
    dispatch(fetchClear('EDIT_USER'));

    if (error === 'Forbidden' || error === 'Unauthorized') {
      window.location = `${window.location.origin}/#/no-access`;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  loadUsers = () => (dispatch) => {
    dispatch(doFetchUser(
      fetchUsers()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 403) {
              window.location = `${window.location.origin}/#/no-access`;
            }
            throw res.statusText;
          }
          return res.json();
        }),
      { search: '' },
    ));
  }

  render() {
    const {
      classes, history, dispatch,
      users: {
        fetched, fetching, error: fetchError, payload: { Resources: data },
        selectedTable, selectedPage,
      },
      editUser: {
        fetched: editUserFetched,
        error: editUserError,
      },
    } = this.props;
    const {
      search, currentRowPerPage,
    } = this.state;

    const min = selectedPage * currentRowPerPage;
    const max = min + currentRowPerPage - 1;

    const filtered = data ? data
      .filter(item => (`${item.givenName ? item.givenName.toLowerCase().trim() : ''} ${item.familyName ? item.familyName.toLowerCase().trim() : ''}, ${item.parties && item.parties.length > 0 && item.parties[0].display ? item.parties[0].display.toLowerCase().trim() : ''}`)
        .includes(search.toLowerCase()) || search === '') : [];

    const options = [5, 10, 25, 100];
    let pagination = [];
    if (fetched && !fetchError) {
      pagination = filtered.filter(item => {
        switch (item.active) {
          case userConstants.ENABLED:
            return selectedTable === 0;
          case userConstants.DISABLED:
            return selectedTable === 1;
          default:
            return selectedTable === 2;
        }
      });
    }
    const list = pagination.filter((item, i) => i <= max && i >= min);

    return (
      <div className={classes.root}>
        <Typography variant="h4" className={classes.mb} color="primary">Brukere</Typography>
        <div className={classes.flex}>
          <TextField
            className={classes.search}
            label="Søk etter bruker (navn eller parti)"
            margin="dense"
            value={search}
            onChange={(e) => { this.setState({ search: e.target.value }); dispatch(updateSelectedPage(0)); }}
          />
          <Button variant="outlined" color="primary" onClick={() => { history.push('/admin/users/leggtil'); }} className={classes.button}>
            + Registrer ny bruker
          </Button>
        </div>
        <Tabs
          className={classes.tabs}
          value={selectedTable}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => {
            if (value !== selectedTable) {
              dispatch(updateSelectedTable(value));
            }
            dispatch(updateSelectedPage(0));
          }}
        >
          <Tab label="Aktiverte" className={classes.tab} />
          <Tab label="Deaktiverte" className={classes.tab} />
          <Tab label="Til godkjenning" className={classes.tab} />
        </Tabs>
        {!fetchError ? (
          <div>
            <List key={1} component="nav" disablePadding>
              <Divider />
              {list.length > 0 && list
                .map(({
                  givenName, familyName, parties, id, active, roles,
                }, i) => [
                  <MuiListItem key={id} className={clsx(i % 2 !== 0 && classes.odd, classes.listitem)} divider button onClick={() => history.push(`/admin/users/id-${id}`)}>
                    <MuiListItemText
                      primary={`${givenName || ''} ${familyName || ''}`}
                      secondary={`${roles ? `Rolle(r): ${roles.map(item => rolesDisplay[item])}.` : ''}  ${parties && parties.length > 0 ? `Parti: ${(parties[0].display)}` : ''}`}
                      className={classes.muilistitemtext}
                    />
                    <ListItemSecondaryActions>
                      {active === 1 ? [
                        <Hidden key={0} smUp>
                          <IconButton onClick={() => { history.push(`/admin/users/endre-${id}`); }}>
                            <EditButton color="primary" />
                          </IconButton>
                        </Hidden>,
                        <Hidden key={1} xsDown>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => { history.push(`/admin/users/endre-${id}`); }}
                            className={classes.editButton}
                          >
                            Rediger
                          </Button>
                        </Hidden>,
                      ] : [
                        <Button
                          key={0}
                          variant="contained"
                          color="secondary"
                          className={classes.activate}
                          onClick={() => { history.push(`/admin/users/endre-${id}`); }}
                        >
                          {active !== 2 ? 'Aktiver' : 'Behandle søknad'}
                        </Button>,
                      ]}
                    </ListItemSecondaryActions>
                  </MuiListItem>,
                ])}
              {fetching && Object.keys(Array(5).fill(0))
                .map(val => (
                  <ListItem
                    key={`skel-${val}`}
                    primary={<Skeleton />}
                    secondary={<Skeleton />}
                  />
                ))
              }
              {!fetching && list.length === 0 && (
                <MuiListItem divider>
                  <MuiListItemText primary="Ingen brukere i listen" secondary="Prøv å søk noe annet eller se annen liste" />
                </MuiListItem>
              )}
            </List>
            {!fetching && list.length > 0 && [
              <Hidden xsDown key="hidden1">
                <TablePagination
                  component="nav"
                  page={selectedPage}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                  labelRowsPerPage="Brukere per side"
                  rowsPerPage={currentRowPerPage}
                  rowsPerPageOptions={options}
                  count={filtered.filter(item => (
                    // eslint-disable-next-line no-nested-ternary
                    item.active === userConstants.ENABLED ? selectedTable === 0 : (
                      item.active === userConstants.DISABLED ? selectedTable === 1
                        : selectedTable === 2
                    ))).length}
                  onChangePage={(e, page) => dispatch(updateSelectedPage(page))}
                  onChangeRowsPerPage={(e) => { this.setState({ currentRowPerPage: e.target.value }); dispatch(updateSelectedPage(0)); }}
                />
              </Hidden>,
              <Hidden smUp key="hidden2">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.showingtext}>
                      {`Viser side ${selectedPage + 1} av ${Math.ceil((filtered.filter(item => (
                        // eslint-disable-next-line no-nested-ternary
                        item.active === userConstants.ENABLED ? selectedTable === 0 : (
                          item.active === userConstants.DISABLED ? selectedTable === 1
                            : selectedTable === 2
                        ))).length) / currentRowPerPage)}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => dispatch(updateSelectedPage(selectedPage - 1))}
                      disabled={selectedPage === 0}
                      fullWidth
                    >
                    Forrige side
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      disabled={(selectedPage + 1) >= (filtered.filter(item => (
                        // eslint-disable-next-line no-nested-ternary
                        item.active === userConstants.ENABLED ? selectedTable === 0 : (
                          item.active === userConstants.DISABLED ? selectedTable === 1
                            : selectedTable === 2
                        ))).length) / currentRowPerPage}
                      onClick={() => dispatch(updateSelectedPage(selectedPage + 1))}
                    >
                    Neste side
                    </Button>
                  </Grid>
                </Grid>
              </Hidden>,
            ]}
          </div>
        ) : (
          <NotificationBar message="Feil ved henting av brukere" variant="error" />
        )}
        { editUserFetched && !editUserError && <NotificationBar message="Bruker er endret!" variant="success" /> }
      </div>
    );
  }
}

Overview.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  users: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  editUser: PropTypes.any.isRequired,
};

const styles = theme => ({
  mb: {
    marginBottom: '0.5rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    marginBottom: '1rem',
    flexWrap: 'wrap-reverse',
  },
  button: {
    minWidth: '13rem',
    marginTop: '8px', // same as Material Ui TextField
    marginBottom: '4px', // same as Material UI TextField
  },
  search: {
    minWidth: '17rem',
  },
  root: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  tabs: {
    minHeight: '2rem',
  },
  tab: {
    maxHeight: '3rem',
    minHeight: 0,
  },
  activate: {
    '&:hover': {
      backgroundColor: '#00953b',
      color: '#fff',
    },
  },
  editButton: {
    minWidth: '6rem',
  },
  muilistitemtext: {
    padding: 0,
  },
  odd: {
    backgroundColor: '#f7f7f7',
  },
  listitem: {
    minHeight: '4.25rem',
    '&:hover, &:focus': {
      borderLeft: `0.2rem solid ${theme.palette.primary.main}`,
    },
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
  showingtext: {
    color: '#808080',
    marginTop: '1rem',
  },
});

const mapStateToProps = ({ users, editUser }) => {
  if (!users.selectedTable) {
    users.selectedTable = 0;
  }
  if (!users.selectedPage) {
    users.selectedPage = 0;
  }
  return (
    {
      users,
      editUser,
    }
  );
};

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Overview)));
